// Single source of truth for company details.
// Placeholder fields (address / phone / emails / socials) still to be
// supplied by the user before production launch.

const DEFAULT_DOMAIN = "https://axion-grp.com";

export const siteConfig = {
  COMPANY_NAME: "Axion Group",
  SHORT_NAME: "Axion",
  TAGLINE: "Specialised Printing & Coding Solutions for Pharmaceutical Manufacturing",
  SECONDARY_TAGLINE:
    "Reliable printing inks, coding consumables and production solutions supplied to pharmaceutical manufacturers and distribution partners worldwide.",
  ADDRESS_CITY: "Dubai, United Arab Emirates",
  ADDRESS_COUNTRY: "AE",
  ADDRESS_STREET: "CWS-1V-228205, Amber Gem Tower, Ajman, UAE",
  // Structured components for JSON-LD PostalAddress. Kept alongside the
  // display-only ADDRESS_STREET so schema.org consumers get typed fields.
  ADDRESS_LINE_1: "CWS-1V-228205, Amber Gem Tower",
  ADDRESS_LOCALITY: "Ajman",
  PHONE: "[Phone to be provided]",
  WHATSAPP: "[WhatsApp number to be provided]",
  EMAIL_SALES: "info@axion-grp.com",
  EMAIL_TECH: "info@axion-grp.com",
  BUSINESS_EMAIL: "info@axion-grp.com",
  LINKEDIN_URL: "https://www.linkedin.com/company/axion-grp/",
  MAPS_EMBED: "[Google Maps embed to be provided]",
  DOMAIN: (process.env.REACT_APP_SITE_URL || DEFAULT_DOMAIN).replace(/\/$/, ""),
  SITE_URL: (process.env.REACT_APP_SITE_URL || DEFAULT_DOMAIN).replace(/\/$/, ""),
  LOGO_PATH: "/brand/axion-logo-primary.png",
  LOGO_INVERSE_PATH: "/brand/axion-logo-inverse.png",
  LOGO_ICON_PATH: "/brand/axion-icon.png",
  GA_MEASUREMENT_ID: process.env.REACT_APP_GA_ID || "",
  GTM_ID: process.env.REACT_APP_GTM_ID || "",
  CURRENT_YEAR: new Date().getFullYear(),
};

// Absolute URL to the primary logo — used in JSON-LD Organization schema
// and as the default OpenGraph share image.
export const absoluteLogoUrl = () => `${siteConfig.DOMAIN}${siteConfig.LOGO_PATH}`;

// WhatsApp click-through link (renders even with placeholder token).
export const whatsappHref = () => {
  const number = encodeURIComponent(siteConfig.WHATSAPP);
  const text = encodeURIComponent(
    "Hello, I would like to discuss a pharmaceutical printing or coding requirement."
  );
  return `https://wa.me/${number}?text=${text}`;
};

// Shared placeholder detector — a field value is considered "not yet
// provided" when it's falsy or its trimmed form begins with `[`. Used by
// display components to hide UI (contact cards, footer social icons, map
// embed) until real data is populated.
export const isPlaceholder = (val) =>
  !val || typeof val !== "string" || val.trim().startsWith("[");

export default siteConfig;

// Build fingerprint: contact-info-2026-02-06 (auto-generated on last update — safe to overwrite)
